import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Discussion, PanelMember, User } from "../../../../models";

@Component({
  selector: "del-panelSeat-auth-modal",
  templateUrl: "./del-panelSeat-auth-modal.component.html",
  styleUrls: [
    "./del-panelSeat-auth-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DelPanelSeatAuthModal implements OnInit {
  // variables to pass on to modal form
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() canModifyDiscussion: boolean;

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
